/**
 * A "Show" round is an artificial presentation round that runs *after* the final
 * and sources its participants/ranking from the final round. It is stored as a
 * show-type round (`isFinal === false`) and is distinguished only by `roundName`
 * containing "Show" (mirrors the parent app's `isShow`, and the existing PWA
 * convention `roundName.includes('Show')`). "General Look" — the show-type round
 * *before* the first round — does not contain "Show" and is intentionally excluded.
 *
 * Because a Show round carries the final's ranking, its results must be displayed
 * and highlighted exactly like a final.
 */
export const isShowRound = (
  round?: { isFinal?: boolean; roundName?: string } | null
): boolean =>
  !!round && !round.isFinal && (round.roundName?.includes('Show') ?? false);
